export const campaign = {
  field: {
    name: 'Название',
    status: 'Статус',
    max_attempts: 'Максимальное кол-во попыток',
    attempts_interval_min: 'Время между попытками (мин.)',
    calls_limit: 'Кол-во одновременных звонков',
    caller_id: 'Номер автоинформатора',
    pbx_number: 'Номер виртуальной АТС',
    progress: 'Прогресс',
    call_schedule: 'Расписание обзвона',
    attempts: 'Количество попыток',
    dial_timeout: 'Максимальное время ожидания (сек.)',
    need_amd: 'Включить распознавание автоответчика'
  },

  deleted: 'удалена',

  tooltips: {
    dial_timeout: 'Максимальное время ожидания ответа клиента на звонок',
    need_amd: 'Answering Machine Detection - модель, позволяющая распознавать  автоответчики, тишину'
  },

  table: {
    action: {
      show_detail_stat: 'Посмотреть статистику',
      create: 'Добавить кампанию'
    }
  },

  filter: {
    status: {
      title: '@:autoinformer.campaign.field.status',
      active: 'Активная',
      not_active: 'Неактивная',
      all: 'Все'
    },

    name: {
      title: '@:autoinformer.campaign.field.name'
    },

    pbx_number: {
      title: '@:autoinformer.campaign.field.pbx_number'
    },

    caller_id: {
      title: '@:autoinformer.campaign.field.caller_id'
    }
  },

  modal: {
    remove: {
      content: `Вы действительно хотите удалить кампанию <b>{name}<b>?`
    },

    delete_scheme: 'Вы уверены, что хотите удалить существующую схему?',

    change_status: {
      enable: 'Вы уверены, что хотите запустить предиктивный обзвон?',
      disable: 'Вы уверены, что хотите остановить предиктивный обзвон?'
    },

    notice_pbx_module_required: {
      content:
        'Для создания кампаний предиктивного обзвона подключите услугу "<strong>Виртуальная АТС</strong>".',
      ok: 'Подключить'
    },

    create_scheme: {
      title: 'Создать схему',
      option1: 'Аудиосообщение',
      option2: 'IVR-меню',
      option3: 'Своя схема'
    }
  },

  create: {
    title: '@:autoinformer.breadcrumb.campaign.new'
  },

  edit: {
    title: '@:autoinformer.breadcrumb.campaign.edit'
  },

  tasks: {
    title: 'Список задач кампании'
  },

  form: {
    title: 'Основная информация',
    title_schedule: 'Расписание обзвона',
    recipients_title: 'Получатели',
    save_btn: 'Сохранить',
    update_btn: 'Обновить',
    calling_scheme: 'Схема обзвона',
    buttons: {
      create_scheme: 'Создать схему'
    }
  }
};
